import React, { useEffect, useReducer } from 'react'
import './lib/ui/ui.css'
import { urlParamsToMap } from './lib/util/urls'
import { ProfessionalDetails } from './components/ProfessionalDetails'
import { Action, Route } from './types/app'
import { authedGet } from './lib/util/http'
import { Dashboard } from './components/Dashboard'
import { ProjectDetails } from './components/ProjectDetails'

const initialize = async (dispatch: any) => {
  // first of all, load the current user - we won't do anything if they are not logged in
  const userResult = await authedGet('user')
  const user = await userResult.json()
  dispatch({ name: 'USER_LOADED', payload: user.data })

  const fromUrlParams = maybeSetPageFromUrl()
  if (fromUrlParams) {
    dispatch({ name: 'NAVIGATE', payload: fromUrlParams })
  } else {
    dispatch({ name: 'NAVIGATE', payload: { page: 'DASHBOARD' } })
  }
}

const maybeSetPageFromUrl = () => {
  const params = urlParamsToMap(window.location.search)
  if (!params.page) return undefined

  const pageName = params.page.toUpperCase()
  delete params.page
  return {
    page: pageName,
    params,
  }
}

const reducer: React.Reducer<AppState, Action> = (
  state: AppState,
  action: Action
) => {
  switch (action.name) {
    case 'NAVIGATE':
      return {
        ...state,
        route: {
          page: action.payload.page,
          params: action.payload.params,
        },
      }
    case 'USER_LOADED':
      return {
        ...state,
        user: action.payload,
      }
    default:
      console.error(`Invalid action: `, action)
      return state
  }
}

interface AppState {
  user?: object
  route: Route
}

export function CopraAdmin() {
  const initialAppState: AppState = {
    route: {
      page: '',
      params: {},
    },
    user: undefined,
  }

  const [state, dispatch] = useReducer<React.Reducer<AppState, Action>>(
    reducer,
    initialAppState
  )

  useEffect(() => {
    initialize(dispatch)
  }, [])

  const pageName = state.route.page
  const props = {
    ...state,
    navigate: ({ page, params }: { page: string; params: object }) =>
      dispatch({ name: 'NAVIGATE', payload: { page, params } }),
  }
  return (
    <div className="copra-admin-container">
      {pageName === 'PROFESSIONAL_DETAILS' && (
        <ProfessionalDetails {...props} />
      )}
      {pageName === 'DASHBOARD' && <Dashboard {...props} />}
      {pageName === 'PROJECT_DETAILS' && <ProjectDetails {...props} />}
    </div>
  )
}
